module.exports = __webpack_public_path__ + "media/images/Groupe 63530-7aaddc02c724de89b8857852301aef87.svg";